import { getRelativeProductImageUrl } from '@dustin-web/microsite-components/src/utils/urls'
import Image from '@dustin-web/microsite-components/src/image'
import classNames from 'classnames'

type ImageSingleProps = {
  imageId: string | null
  slugText: string
  fullScreen?: boolean
  toggleModal?: () => void
}

export default function ImageSingle({
  imageId,
  slugText,
  fullScreen,
  toggleModal = () => {},
}: ImageSingleProps) {
  const width = fullScreen ? 900 : 400
  const height = fullScreen ? 900 : 320

  const imageUrl = getRelativeProductImageUrl(imageId, width, height, slugText)

  return (
    <div
      className={classNames('flex-fill d-flex align-items-center justify-content-center', {
        'u-cursor-pointer': !fullScreen,
      })}>
      <Image
        priority={true}
        width={width}
        height={height}
        src={imageUrl}
        alt={slugText}
        onClick={toggleModal}
      />
    </div>
  )
}
